var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('sticky',{ref:"sticky",on:{"stickinessChanged":_vm.handleSticky}},[_c('header',[_vm._t("header")],2)]),_c('main',{style:({ 'padding-top': _vm.mainPaddingTop })},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }